import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { toast } from 'react-toastify';

const AddCustomerImage = () => {
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);

    if (file) {
      const url = URL.createObjectURL(file);
      setPreview(url);
    } else {
      setPreview(null);
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!imageFile) {
    toast.error("Please select an image to upload.");
    return;
  }

  // 🔒 Image size validation (max 2MB)
  const maxSize = 2 * 1024 * 1024; // 2 MB in bytes
  if (imageFile.size > maxSize) {
    toast.error("Image size should not exceed 2 MB.");
    return;
  }

  const formData = new FormData();
  formData.append('image', imageFile);

  try {
    setLoading(true);
    const res = await DataService.uploadImage(formData);
    if (res.data.success) {
      toast.success("Image uploaded successfully.");
      navigate('/customer-images');
    } else {
      toast.error(res.data.error || "Failed to upload image.");
    }
  } catch (err) {
    console.error(err);
    toast.error("An error occurred during image upload.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div>
      <LoaderOverlay loading={loading} />
      <h4>Add Customer Image</h4>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="mb-3">
          <label className="form-label">Select Image</label>
          <input type="file" className="form-control" accept="image/*" onChange={handleFileChange} />
        </div>

        {preview && (
          <div className="mb-3">
            <img src={preview} alt="Preview" style={{ maxWidth: '100%', height: 'auto' }} />
          </div>
        )}

        <button type="submit" className="btn btn-primary">Upload</button>
        <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate('/customer-images')}>
          Cancel
        </button>
      </form>
    </div>
  );
};

export default AddCustomerImage;
